// TabComponent.js
import React, { useState } from "react";
import ReviewSendDashoard from "../ui/ReviewSendDashboard";
import SetReminders from "../ui/SetReminders";
import Shipping from "../ui/Shipping";

const CreditReviewSend = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "Dashboard",
      content: <ReviewSendDashoard />,
    },
    {
      title: "Set Reminders",
      content: <SetReminders />,
    },
    {
      title: "Shipping",
      content: <Shipping />,
    },
  ];

  return (
    <div className="tabs-container">
      {/* Render tab titles */}
      <div className="tabs">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab ${activeTab === index ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.title}
          </button>
        ))}
      </div>

      {/* Render active tab content */}
      <div className="tab-content">{tabs[activeTab].content}</div>
    </div>
  );
};

export default CreditReviewSend;
